import {$http} from './index';
import {sxhr} from 'fire-wind-water/sxhr';

export const userService = {
  getIP() {
    return sxhr.getScript('https://api.smarket.net.cn/cityjson');
  },

  getId(info, cn) {
    const path = 'anonymous/getId';
    $http(path, info).then(res => {
      cn(res);
    });
  },

  checkSess(info, cn) {
    const path = 'anonymous/checkSess';
    $http(path, info).then(res => {
      cn(res);
    }, res => {
      cn(res);
    });
  }
};